export default "__VITE_ASSET__UsZ$5j$a__"